'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _minimajs = require('minimajs');

var _artTemplate = require('art-template');

var _artTemplate2 = _interopRequireDefault(_artTemplate);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _Activator = require('../Activator');

var _Activator2 = _interopRequireDefault(_Activator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PluginsByArtViewRender = function () {
    function PluginsByArtViewRender() {
        (0, _classCallCheck3.default)(this, PluginsByArtViewRender);

        this.render = this.render.bind(this);
    }

    (0, _createClass3.default)(PluginsByArtViewRender, [{
        key: 'render',
        value: function render() {
            var pluginContext = _Activator2.default.context;
            var plugin = _Activator2.default.context.plugin;
            var pluginsView = _path2.default.join(plugin.pluginDirectory, 'views/plugins.html');

            this.plugins = [];
            var index = 1;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(pluginContext.getPlugins()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    var _plugin = {
                        'index': index,
                        'id': pair[1].id,
                        'name': pair[1].name,
                        'version': pair[1].version.versionString,
                        'state': pair[1].state.state
                    };
                    this.plugins.push(_plugin);
                    index++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var pluginsData = { pluginId: plugin.id, plugins: this.plugins };

            return (0, _artTemplate2.default)(pluginsView, pluginsData);
        }
    }]);
    return PluginsByArtViewRender;
}();

exports.default = PluginsByArtViewRender;
//# sourceMappingURL=PluginsViewRender.js.map